import Radio_module_default from "./Radio.module.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { Control } from "@radix-ui/react-form";
//#region src/components/Form/Controls/Radio/Radio.tsx
/**
* A radio component.
*/
var RadioInput = forwardRef(function Radio({ className, ...props }, ref) {
	return /* @__PURE__ */ jsxs("div", {
		className: classNames(Radio_module_default.container, className),
		children: [/* @__PURE__ */ jsx("input", {
			ref,
			...props,
			className: Radio_module_default.input,
			type: "radio"
		}), /* @__PURE__ */ jsx("div", { className: Radio_module_default.ui })]
	});
});
var RadioControl = forwardRef(function RadioControl(props, ref) {
	return /* @__PURE__ */ jsx(Control, {
		asChild: true,
		children: /* @__PURE__ */ jsx(RadioInput, {
			ref,
			...props
		})
	});
});
//#endregion
export { RadioControl, RadioInput };

//# sourceMappingURL=Radio.js.map